export default __webpack_public_path__ + "static/media/logo2.3b959239.png";